import { Controller, useFormContext } from "react-hook-form";

import { CustomInvokeCodeEditor } from "src/aiNode/CustomInvokeCodeEditor";
import { Card } from "src/base-components/Card";
import { FormItem } from "src/base-components/FormItem";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
  isReactive: boolean;
};

export const AgentPromptEditor: React.FC<Props> = ({
  immutable,
  isReactive,
}) => {
  const { control } = useFormContext<AgentNodeData>();

  return (
    <Card className="w-full pb-4 pt-4">
      <FormItem>
        <FormItem.Label
          className="mb-2"
          description="Optional user invocation message for the agent. Use '$' to include Flow data (e.g.
            '$data.credit_report') from your Decision Flow."
        >
          Message
        </FormItem.Label>
        <Controller
          control={control}
          name="prompt"
          render={({ field }) => (
            <div className="h-80">
              <CustomInvokeCodeEditor
                immutable={immutable}
                isReactive={isReactive}
                placeholder="e.g. You are a helpful assistant. Please analyze the following data and provide insights."
                value={field.value as string}
                onChange={field.onChange}
              />
            </div>
          )}
        />
      </FormItem>
    </Card>
  );
};
